/**
 * Get API key(s) from WordPress settings based on provider name
 *
 * @param {string} [providerName] - The name of the provider (unsplash, pexels, giphy, pixabay, openverse)
 * @returns {Promise<Object|string[]|false>} A promise that resolves to an object of API keys, an array of keys for a specific provider, or false if not found
 */

export const PROVIDERQUERY = {
	PIXABAY: {
		searchTerm: {
			name: "q",
		},
		type: {
			name: "type",
			acc_values: ["all", "photo", "illustration", "vector"],
			default: "all",
		},
		category: {
			name: "category",
			acc_values: [
				"backgrounds",
				"fashion",
				"nature",
				"science",
				"education",
				"feelings",
				"health",
				"people",
				"religion",
				"places",
				"animals",
				"industry",
				"computer",
				"food",
				"sports",
				"transportation",
				"travel",
				"buildings",
				"business",
				"music",
			],
		},
		orientation: {
			name: "orientation",
			acc_values: ["all", "horizontal", "vertical"],
			default: "all",
		},
		color: {
			name: "colors",
			acc_values: [
				"grayscale",
				"transparent",
				"red",
				"orange",
				"yellow",
				"green",
				"turquoise",
				"blue",
				"lilac",
				"pink",
				"white",
				"gray",
				"black",
				"brown",
			],
		},
		min_height: {
			name: "min_height",
			default: 0,
		},
		min_width: {
			name: "min_width",
			default: 0,
		},
	},
	PEXELS: {
		searchTerm: {
			name: "query",
		},
		orientation: {
			name: "orientation",
			acc_values: ["landscape", "portrait", "square"],
		},
		color: {
			name: "color",
			acc_values: [
				"red",
				"orange",
				"yellow",
				"green",
				"turquoise",
				"blue",
				"violet",
				"pink",
				"brown",
				"black",
				"gray",
				"white",
			],
		},
		size: {
			name: "size",
			acc_values: ["large", "medium", "small"],
		},
	},
	GIPHY: {
		searchTerm: {
			name: "q",
		},
	},
	OPENVERSE: {
		searchTerm: {
			name: "q",
		},
		extension: {
			name: "extension",
			acc_values: ["JPG", "JPEG", "PNG", "GIF"]
		},
		orientation: {
			name: "aspect_ratio",
			acc_values: ["square", "wide", "tall"],
		},
		size: {
			name: "size",
			acc_values: ["large", "medium", "small"],
		},
		category: {
			name: "category",
			acc_values: ["digitized_artwork", "illustration", "photograph"],
		},
		license_type: {
			name: "license_type",
			acc_values: ["all", "all-cc", "commercial", "modification"],
			values_labels: ["All", "All CC", "Commercial", "Modification"],
		},
		license: {
			name: "license",
			acc_values: [
				"cc0",
				"by",
				"by-sa",
				"by-nd",
				"by-nc",
				"by-nc-sa",
				"by-nc-nd",
			],
			values_labels: [
				"CC0",
				"CC BY",
				"CC BY-SA",
				"CC BY-ND",
				"CC BY-NC",
				"CC BY-NC-SA",
				"CC BY-NC-ND",
			],
		}
	},
	UNSPLASH: {
		searchTerm: {
			name: "query",
		},
		orientation: {
			name: "orientation",
			acc_values: ["landscape", "portrait", "squarish"],
			default: "all",
		},
		color: {
			name: "color",
			acc_values: [
				"black_and_white",
				"black",
				"white",
				"yellow",
				"orange",
				"red",
				"purple",
				"magenta",
				"green",
				"teal",
				"blue",
			],
		},
	},
};

export const UnsplashIconURL = image_hub_data.unsplashLogoUrl;
export const OpenverseIconURL = image_hub_data.openverseLogoUrl;
export const GiphyIconURL = image_hub_data.giphyLogoUrl;
export const PexelsIconURL = image_hub_data.pexelsLogoUrl;
export const PixabayIconURL = image_hub_data.pixabayLogoUrl;
export const TransparentBG = image_hub_data.transparentBG;
export const PROVIDERS = {
	All: { name: "All", icon: null, enabled: false },
	PEXELS: { name: "pexels", icon: PexelsIconURL, enabled: false },
	UNSPLASH: { name: "unsplash", icon: UnsplashIconURL, enabled: false },
	PIXABAY: { name: "pixabay", icon: PixabayIconURL, enabled: false },
	OPENVERSE: { name: "openverse", icon: OpenverseIconURL, enabled: false },
	GIPHY: { name: "giphy", icon: GiphyIconURL, enabled: false },
};

export const ucfirst = (str) => {
	if (!str) return '';
	return str.charAt(0).toUpperCase() + str.slice(1);
  }